import Joi from 'joi-full';

import config from '../../../config';

export const customer = Joi.object().keys({
  firstName: Joi.string()
    .required()
    .min(2)
    .label('First name'),
  lastName: Joi.string()
    .allow('', null)
    .max(100)
    .optional()
    .label('Last name'),
  email: Joi.string()
    .allow('', null)
    .email({ minDomainAtoms: 2 })
    .optional()
    .label('Email'),
  phone: Joi.string()
    .allow('', null)
    .optional()
    .label('Phone')
    .options({
      language: { string: { regex: { base: ' is not valid format.' } } },
    }),
  birthDate: Joi.date()
    .allow('')
    .optional()
    .format(config.dateFormat)
    .label('Birthday')
    .options({
      language: { date: { base: ` must be in ${config.dateFormat} format.` } },
    }),
  notes: Joi.string()
    .min(3)
    .allow('', null)
    .optional()
    .label('Notes'),
});
